module.exports = __webpack_public_path__ + "img/sea-projects.87485048.png";